import { getToken, setToken, removeToken} from '@/utils/auth'

const user = {
  state: {
    token: getToken(), name: '', avatar: '', roles: [], role_id:0, id: 0, depart_id: 0, depart_name: '', user_type: '', depart_ids: [], loadMenus: false, btns:[]
  },
  mutations:{
    saveUser(state,userData){
      Object.assign(state,userData);
    },
    saveToken(state,token){
      state.token = token;
    },
    saveMenuFlag(state){state.loadMenus=true},
  },
  actions: {
    login({commit,state}, rr) {
      return new Promise((res,rej)=>{
        commit('saveUser',rr.data)
        localStorage.setItem('vue_store_user', JSON.stringify(rr.data))
        setToken(rr.token)
        res(true);
      });
    },
    reloadUser({commit,state}) {
      let usr = localStorage.getItem('vue_store_user');
      commit('saveUser',JSON.parse(usr))
      commit('saveToken',getToken())
    },
    logout({commit,state}) {
      return new Promise((res,rej)=>{
        state.user = null
        var theme_name = localStorage.getItem('theme_name')+'';
        var layout = localStorage.getItem('layout')+'';
        var main_page = localStorage.getItem('main_page')+'';
        localStorage.clear();
        localStorage.setItem('theme_name',theme_name=='null'?'theme_default':theme_name);
        localStorage.setItem('layout',layout=='null'?'layout_tb':layout);
        localStorage.setItem('main_page',main_page=='null'?'/back/dashboard':main_page);
        removeToken();
        res(true);
      })
    },
    resetToken(state,token){
      state.user.token = token;
    },
    updateLoadMenus({commit,state}){
      return new Promise((res,reject)=>{
        commit('saveMenuFlag')
        res(true)
      })
    },
  },
  getters: {
    isLoggedIn: state => {
      return state.user !== null
    }
  }
}

export default user;
